import React from 'react';

export default function Button(props: any): React.Element {
  const {
    children,
    className,
    disabled,
    style,
    customDataTestID,
    ...rest
  } = props;
  return (
    <button
      data-testid={customDataTestID}
      className={`mdl-button ${className || ''}`}
      disabled={disabled}
      style={{
        fontWeight: 300,
        ...style,
      }}
      type="button"
      {...rest}
      >
      {children}
    </button>
  );
}
